import type { TaskStatus } from "../types";

interface StatusBadgeProps {
	status: TaskStatus;
	size?: "sm" | "md";
}

const statusConfig: Record<TaskStatus, { label: string; className: string }> = {
	todo: {
		label: "未着手",
		className: "bg-gray-100 text-gray-700 border-gray-300",
	},
	in_progress: {
		label: "進行中",
		className: "bg-blue-100 text-blue-700 border-blue-300",
	},
	done: {
		label: "完了",
		className: "bg-green-100 text-green-700 border-green-300",
	},
};

export function StatusBadge({ status, size = "md" }: StatusBadgeProps) {
	const config = statusConfig[status];
	const sizeClasses = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";

	return (
		<span
			className={`inline-flex items-center font-medium rounded-full border ${sizeClasses} ${config.className}`}
		>
			{config.label}
		</span>
	);
}
